import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthorizationService } from '../services/authorization.service';
import { Role } from 'src/app/pages/anvandare/anvandare.models';

export const isAuthorizedGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Add more logic here (roles etc.)

  let isAuthorized = auth.loggedIn;

  if (!isAuthorized) {
    router.navigate(['logga-in']);
  }

  return isAuthorized;
};

export const hasOperativeRoleGuard: CanActivateFn = () => {
  const authorizationService = inject(AuthorizationService);

  return authorizationService.hasRole([
    Role.BasanvandareIntern,
    Role.BasanvandareExtern,
    Role.SuperanvandareIntern,
    Role.SuperanvandareExtern,
  ]);
};

export const isInternSuperUserGuard: CanActivateFn = () => {
  const authorizationService = inject(AuthorizationService);

  return authorizationService.hasRole([Role.SuperanvandareIntern]);
};

export const canCreateUserGuard: CanActivateFn = () => {
  const authorizationService = inject(AuthorizationService);

  return authorizationService.hasRole([Role.Systemadministrator, Role.BehorighetsadministratorExtern]);
};

export const isAdminGuard: CanActivateFn = () => {
  const authorizationService = inject(AuthorizationService);

  return authorizationService.hasRole([
    Role.Systemadministrator,
    Role.BehörighetsadministratörIntern,
    Role.BehorighetsadministratorExtern,
  ]);
};
